export enum ProductType {
  Assistance = 'assistance',
  Bicycle = 'bicycle',
  Boat = 'boat',
  Car = 'car',
  Health = 'health',
  House = 'house',
  LegalProtection = 'legal_protection',
  LifeAsrd = 'life_asrd',
  LifeNonTaxInvestment = 'life_non_tax_investment',
  LifeCpti = 'life_cpti',
  LifeEip = 'life_eip',
  LifeGroup = 'life_group',
  LifePlci = 'life_plci',
  LifeSavingsLongTerm = 'life_savings_long_term',
  LifeSavingsShortTerm = 'life_savings_short_term',
  Miscellaneous = 'miscellaneous',
  Motorbike = 'motorbike',
  PersonalLiability = 'personal_liability',
  ProfessionalLiability = 'professional_liability',
  WorkersCompensation = 'workers_compensation'
}

export type LifeProductType =
  | ProductType.LifeAsrd
  | ProductType.LifeSavingsShortTerm
  | ProductType.LifeCpti
  | ProductType.LifeEip
  | ProductType.LifeGroup
  | ProductType.LifePlci
  | ProductType.LifeSavingsLongTerm
  | ProductType.LifeNonTaxInvestment

export const LifeProductTypes = [
  ProductType.LifeAsrd,
  ProductType.LifeSavingsShortTerm,
  ProductType.LifeCpti,
  ProductType.LifeEip,
  ProductType.LifeGroup,
  ProductType.LifePlci,
  ProductType.LifeSavingsLongTerm,
  ProductType.LifeNonTaxInvestment
]

export const VehicleProductTypes = [ProductType.Car, ProductType.Motorbike, ProductType.Boat]
